<template>
  <v-container pt-0 pb-0>
    <div>
      <settings-bar :parent="'stats'" :width="'330'" @go-to-path="goToPath()" />
    </div>
    <v-flex layout column>
      <v-flex layout align-center justify-center pt-2 pb-4>
        <v-card-title class="justify-center">
          <h2 class="font-weight-light">
            {{ $t('stats.pathStats') }} {{ pathInformations.name.fr }}
          </h2>
        </v-card-title>
      </v-flex>

      <v-layout
        column
        align-center
        justify-center
        pb-4
        pt-4
        v-if="!statsPaths[pathId]"
      >
        <v-icon x-large color="grey lighten-2"> mdi-emoticon-sad </v-icon>
        <p class="indicationText">
          {{ $t('stats.noStat') }}
        </p>
        <v-btn
          href="https://support.explorama.app/article/95-comment-lire-et-interpreter-les-statistiques"
          target="_blank"
        >
          {{ $t('stats.noStatLink') }}
        </v-btn>
      </v-layout>

      <v-layout column v-else>
        <v-flex layout row>
          <v-card height="200" width="220" flat class="ml-4 mr-4">
            <v-flex layout column>
              <v-flex layout column justify-center pt-2>
                <v-list :expand="true">
                  <v-list-tile
                    v-for="(period, index) in pathPeriods"
                    :key="index"
                  >
                    <v-btn
                      block
                      :color="
                        pathPeriodSelected === period.type ? 'primary' : 'white'
                      "
                      :outline="
                        pathPeriodSelected === period.type ? true : false
                      "
                      class="text-none elevation-0"
                      @click="changePathView(period.type)"
                    >
                      <span
                        :class="
                          period.type === 'summary' ? 'categoryTitle' : null
                        "
                        >{{ period.name }}</span
                      >
                    </v-btn>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-flex>
          </v-card>
          <stats-path-card
            :height="200"
            :width="500"
            :pathId="pathId"
            :path="pathInformations"
            :statsPath="statsPaths[pathId]"
            :period="pathPeriodSelected"
          />
        </v-flex>

        <v-flex layout row class="mt-4">
          <v-card height="250" width="220" flat class="ml-4 mr-4">
            <v-flex layout column>
              <v-flex layout column justify-center pt-2>
                <v-flex layout pt-2 pl-3 pr-3>
                  <v-btn
                    block
                    :color="missionSelected === 'summary' ? 'primary' : 'white'"
                    :outline="missionSelected === 'summary' ? true : false"
                    class="text-none elevation-0"
                    @click="changeMissionView('summary')"
                  >
                    <span class="categoryTitle">
                      {{ $t('stats.missionsSummary') }}
                    </span>
                  </v-btn>
                </v-flex>
                <v-flex
                  layout
                  column
                  v-if="statsPaths[pathId] && statsPathMissions"
                  :class="
                    statsPathMissions.length > 3 ? 'missionsScroll' : null
                  "
                >
                  <v-list-tile
                    v-for="(mission, index) in statsPathMissions"
                    :key="index"
                  >
                    <v-btn
                      block
                      :color="
                        missionSelected === mission.missionId
                          ? 'primary'
                          : 'white'
                      "
                      :outline="
                        missionSelected === mission.missionId ? true : false
                      "
                      class="text-none elevation-0"
                      @click="changeMissionView(mission.missionId)"
                    >
                      <span class="btnTitle">{{
                        missionInformations(mission.missionId).name.fr
                      }}</span>
                    </v-btn>
                  </v-list-tile>
                </v-flex>
              </v-flex>
            </v-flex>
          </v-card>
          <stats-path-card
            v-if="missionSelected === 'summary'"
            :pathId="pathId"
            :path="pathInformations"
            :statsPath="statsPaths[pathId]"
            :statsPathMissions="statsPathMissions"
            :period="'missionSummary'"
            :height="250"
            :width="500"
          />
          <stats-mission-card
            v-else
            :height="325"
            :width="500"
            :statsMission="statsMission(missionSelected)"
            :missionId="missionSelected"
          />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-container>
</template>

<script>
import SettingsBar from '../components/SettingsBar.vue';
import StatsPathCard from '../components/StatsPathCard';
import StatsMissionCard from '../components/StatsMissionCard';

export default {
  name: 'Stats',
  components: {
    StatsPathCard,
    StatsMissionCard,
    SettingsBar,
  },
  data() {
    return {
      pathPeriodSelected: 'summary',
      missionSelected: 'summary',
    };
  },
  created() {},
  methods: {
    goToPath() {
      this.$router.push(`/pathManagement/${this.pathId}`);
    },
    changePathView(type) {
      this.pathPeriodSelected = type;
    },
    changeMissionView(missionId) {
      this.missionSelected = missionId;
    },
    missionInformations(missionId) {
      return this.$store.getters['missions/getMissionById'](missionId);
    },
    statsMission(missionId) {
      return this.statsPathMissions.find(
        (mission) => mission.missionId === missionId
      );
    },
  },
  computed: {
    statsPaths() {
      return this.$store.state.stats.statsPaths;
    },
    statsPathsIds() {
      return Object.keys(this.statsPaths);
    },
    pathId() {
      return this.$route.params.pathId;
    },
    pathInformations() {
      return this.$store.getters['paths/getPathById'](this.pathId);
    },
    missingMissions() {
      if (!this.statsPathsIds.includes(this.pathId)) {
        return null;
      }
      const missionIds = this.statsPaths[this.pathId].missions.map(
        (mission) => mission.missionId
      );
      console.log(
        'missing',
        missionIds.filter((missionId) => !this.missionInformations(missionId))
      );
      return missionIds.filter(
        (missionId) => !this.missionInformations(missionId)
      );
    },
    statsPathMissions() {
      if (!this.statsPathsIds.includes(this.pathId)) {
        return null;
      }
      return this.statsPaths[this.pathId].missions.filter(
        (mission) => !this.missingMissions.includes(mission.missionId)
      );
    },
    pathPeriods() {
      return [
        {
          type: 'summary',
          name: this.$t('stats.summary'),
        },
        {
          type: 'week',
          name: this.$t('stats.thisWeek'),
        },
        {
          type: 'month',
          name: this.$t('stats.thisMonth'),
        },
      ];
    },
  },
};
</script>
<style lang="sass">
.categoryTitle
  font-size: medium;
.bgdMessage
  color: #dcdcdc
  margin: 20px 0 10px !important
.pathImageStats
  position: absolute;
  bottom: 40px
  min-height: 120px
  max-width: 120px
.numberClass
  width: 30px
.btnTitle
  text-overflow: ellipsis
  overflow: hidden
.missionsScroll
  overflow-y: scroll;
  max-height: 190px;
</style>
